<div
  [ngStyle]="{
    'min-height': minHeight,
    'padding-top': padding,
    'padding-bottom': padding,
  }"
  class="d-flex flex-column align-items-center justify-content-center"
>
  <img
    *ngIf="isImage"
    [ngStyle]="{
      width: size === 'sm' ? '7.5rem' : '12rem',
      height: size === 'sm' ? '7.5rem' : '12rem',
    }"
    src="assets/images/no-results-found.svg"
    alt="No Record(s) Found"
  />

  <h3
    [ngClass]="
      size === 'xs' ? 'text-sm' : size === 'sm' ? 'text-base mt-2' : 'text-xl'
    "
    class="text-center fw-500 mb-0"
  >
    {{ message }}
  </h3>
</div>
